import { render, staticRenderFns } from "./TrainingQualificationUpsertForm.vue?vue&type=template&id=37ee8bf4"
import script from "./TrainingQualificationUpsertForm.vue?vue&type=script&lang=ts"
export * from "./TrainingQualificationUpsertForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports